var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmergencyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 101,
    viewBox: "0 0 110 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6081 100.864C9.04028 100.864 4.93028 98.5151 2.6134 94.5798C0.29651 90.6454 0.237719 85.9132 2.45573 81.9218L43.8479 7.42466C46.13 3.31665 50.2988 0.86377 55.0003 0.86377C59.7018 0.86377 63.8706 3.31665 66.1527 7.42466L107.545 81.9218C109.762 85.9132 109.702 90.6454 107.386 94.5798C105.069 98.5142 100.959 100.864 96.3916 100.864H13.6081Z",
    fill: "#FFF5EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74383 83.1924L46.136 8.69428C49.9984 1.74253 60.0017 1.74253 63.864 8.69428L105.256 83.1924C109.009 89.9473 104.122 98.2471 96.3922 98.2471H13.6079C5.87778 98.2471 0.991028 89.9473 4.74383 83.1924Z",
    fill: "#FFBC77"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8936 94.9083C70.2446 83.5993 81.5636 72.259 92.8772 60.9126L79.3313 36.5325C69.8268 46.0324 60.3215 55.5323 50.817 65.0331C40.4476 75.3984 30.0773 85.7628 19.7078 96.1272L17.5869 98.2471H55.5291C56.6488 97.1324 57.7748 96.0239 58.8936 94.9083Z",
    fill: "#F27C00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1966 63.2881C89.2207 68.2784 84.2503 73.2741 79.2691 78.2591C72.6035 84.9304 65.9298 91.5937 59.2473 98.2472H96.3923C104.122 98.2472 109.009 89.9475 105.256 83.1925L94.1975 63.2881H94.1966Z",
    fill: "#F27C00"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3656 69.7715L45.7067 40.3627V39.8081C45.7067 38.3987 46.8495 37.2563 48.2596 37.2563H61.7396C63.1497 37.2563 64.2925 38.3987 64.2925 39.8081V40.3627L61.5748 69.7759C61.459 71.0295 60.407 71.9884 59.1475 71.9884H50.7929C49.5316 71.9884 48.4787 71.0268 48.3647 69.7706L48.3656 69.7715ZM47.9443 83.6376V77.3651C47.9443 76.2834 48.8217 75.4064 49.904 75.4064H60.0329C61.1152 75.4064 61.9926 76.2834 61.9926 77.3651V83.6376C61.9926 84.7193 61.1152 85.5963 60.0329 85.5963H49.904C48.8217 85.5963 47.9443 84.7193 47.9443 83.6376Z",
    fill: "#323A3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyIcon);
export default __webpack_public_path__ + "static/media/EmergencyIcon.6f9d5d81859d6fdb2fb8aa8d1417cf46.svg";
export { ForwardRef as ReactComponent };